import { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import { roundStates } from "../constants"
import { useTurn } from "./useTurn"

export const useAllowPreviews = () => {
  const { gameState } = useContext(GameContext)
  const { showPreviewTurn } = useTurn()

  const showPreview =
    showPreviewTurn ||
    gameState?.roundState === roundStates.REDISTRIBUTE ||
    false

  return showPreview
}
